import { $api } from '@service/RequestService';
import { useQuery } from 'react-query';

import { productUpdateConstants, productUpdateModels } from '..';

export const useNewsPostSchedule = (props?: { enabled?: boolean }) =>
  useQuery<productUpdateModels.INewsPostSchedule>({
    queryKey: [productUpdateConstants.queryKeys.NEWS_POST_SCHEDULE],
    queryFn: async () => {
      const res = await $api.get('/v1/news-post-schedule');

      return res?.data?.data;
    },
    staleTime: Infinity,
    enabled: props?.enabled
  });
